<div class="container" (click)="onOverlayClick($event)">
  <div class="inner" (click)="activeMenuIndex = null">
    <div class="close-btn-container">
      <div class="close-btn-mobile" (click)="onClosePopup()">
        <img alt="Close" src="/assets/icons/close-icon.svg">
      </div>
    </div>

    <h1 fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY_1"></h1>
    <span class="subtitle" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_SUMMARY_2"></span>

    <div class="container-table">

      <div class="arrow-row">
        <div class="arrow-right" (click)="showOtherColumns(table)" [class.revers]="arrowRight">
          <img alt="arrow" src="/assets/icons/arrow-down.svg">
        </div>
      </div>

      <div class="scroll-container" #table (scroll)="scrollTable(table)">

        <table>
          <thead>
            <tr>
              <th class="type sortable" [class.sorted]="sortDirection !== 'NONE' && sortColumn === 'TYPE'" (click)="sortByColumn('TYPE')">
                <span class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_TYPE"></span>
                <img src="assets/icons/sort-arrows.svg" alt="sort">
              </th>
              <th class="name sortable" [class.sorted]="sortDirection !== 'NONE' && sortColumn === 'NAME'" (click)="sortByColumn('NAME')">
                <span class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_NAME"></span>
                <img src="assets/icons/sort-arrows.svg" alt="sort">
              </th>
              <th class="id sortable" [class.sorted]="sortDirection !== 'NONE' && sortColumn === 'LEAD_NUMBER'" (click)="sortByColumn('LEAD_NUMBER')">
                <span class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_LEADID"></span>
                <img src="assets/icons/sort-arrows.svg" alt="sort">
              </th>
              <th class="date sortable" [class.sorted]="sortDirection !== 'NONE' && sortColumn === 'DATE'" (click)="sortByColumn('DATE')">
                <span class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_DATE"></span>
                <img src="assets/icons/sort-arrows.svg" alt="sort">
              </th>
              <th class="sender sortable" [class.sorted]="sortDirection !== 'NONE' && sortColumn === 'SENDER'" (click)="sortByColumn('SENDER')">
                <span class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_FILES_TABLE_FILES_FROM"></span>
                <img src="assets/icons/sort-arrows.svg" alt="sort">
              </th>

              <th class="mark">

              </th>
              <th class="action" [matMenuTriggerFor]="globalMenu" (click)="activeMenuIndex = -1; $event.stopPropagation()">
                <div class="actions-menu-btn" [class.active]="activeMenuIndex === -1">
                  <img alt="Menu" src="/assets/icons/dots-vertical.svg">
                </div>
                <mat-menu #globalMenu="matMenu" xPosition="before" class="actions-menu"
                  (closed)="activeMenuIndex = null"
                  >
                  <button mat-menu-item class="menu-action-btn download-btn" (click)="downloadAll()">
                    <img src="assets/icons/attachment-download.svg" alt="download" class="icon">
                    <span class="text"
                    fiTranslation="REQUEST_DETAIL_FILES_DOWNLOAD_ALL"></span>
                  </button>

                  <button mat-menu-item class="menu-action-btn delete" (click)="deleteDocuments()">
                    <img src="assets/icons/attachment-delete-file.svg" alt="link" class="icon">
                    <span class="text"
                    fiTranslation="REQUEST_DETAIL_FILES_DELETE_ALL"></span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (doc of documentsToShow; track doc; let i = $index) {
              <tr [class.light-bg]="activeMenuIndex === i"
                [class.hidden]="doc.Deleted">
                <td class="type">
                  @if (doc.MimeType === 'application/pdf') {
                    <img class="clickable-image" alt="PDF"
                      title="Open in a new tab" [src]="uploadHelper.getIconUrlFromMimeType(doc.MimeType)"
                      (click)="openPDF(doc)">
                  }
                  @if (!doc.ThumbnailURL && doc.MimeType !== 'application/pdf') {
                    <img alt="PDF"
                      [src]="uploadHelper.getIconUrlFromMimeType(doc.MimeType)">
                  }
                  @if (doc && doc.ThumbnailURL && doc.ThumbnailURL.includes('image/svg')) {
                    <img
                      #fileType class="clickable-image"
                      (click)="downloadHelper.downloadDocument(doc, leadDataService, true)" alt="PDF"
                      [src]="uploadHelper.getIconUrlFromMimeType(doc.MimeType)" [isTitle]="true"
                      fiTranslation="ALT_TEXT_IMAGE_OPEN_TAB" matTooltip="{{fileType.dataset.matTooltip}}"
                      matTooltipPosition="below" matTooltipClass='tooltip-style'>
                  } @else {
                    @if (doc.ThumbnailURL) {
                      <img #fileType class="clickable-image"
                        (click)="downloadHelper.downloadDocument(doc, leadDataService, true)" alt="PDF"
                        [src]="getImage(doc.ThumbnailURL)" [isTitle]="true"
                        fiTranslation="ALT_TEXT_IMAGE_OPEN_TAB"
                        matTooltip="{{fileType.dataset.matTooltip}}"
                        matTooltipPosition="below" matTooltipClass='tooltip-style'>
                    }
                  }
                </td>
                <td class="name">
                  <div class="name-content">{{ doc.Name }}</div>
                </td>
                <td class="id">{{ doc.LeadNumber }}</td>
                <td class="date">{{ dateTimeHelper.getFormattedDate(doc.Filedate) }} @if (getLanguage() !== 'it') {
                  <span
                  fiTranslation="REQUEST_DETAIL_HISTORY_TIME"></span>
                }
              </td>
              <td class="sender">
                <a href="mailto:{{ doc.Creator }}">{{ doc.Creator }}</a>
              </td>
              <td class="mark">
                @if (!doc.Favorite) {
                  <mat-icon (click)="mark(doc)">
                    star_border
                  </mat-icon>
                }
                @if (doc.Favorite) {
                  <mat-icon (click)="unmark(doc)">
                    star
                  </mat-icon>
                }
              </td>
              <td class="action" [matMenuTriggerFor]="menu" (click)="openMenu($event, i)">
                <div class="actions-menu-btn" [class.active]="activeMenuIndex === i">
                  <img alt="Menu" src="/assets/icons/dots-vertical.svg">
                </div>
                <mat-menu #menu="matMenu" xPosition="before" class="actions-menu" (closed)="activeMenuIndex = null">
                  <button mat-menu-item class="menu-action-btn brows-btn">
                    <a [href]="doc.OpenURL" target="_blank"
                      (click)="downloadHelper.downloadDocument(doc, leadDataService, true)">
                      <img src="assets/icons/attachment-open-in-browser.svg" alt="brows" class="icon">
                      <span class="text"
                      fiTranslation="REQUEST_DETAIL_FILES_TABLE_ACTION_OPEN"></span>
                    </a>
                  </button>
                  <button mat-menu-item class="menu-action-btn download-btn">
                    <a [href]="doc.DownloadURL" target="_blank"
                      (click)="downloadHelper.downloadDocument(doc, leadDataService)">
                      <img src="assets/icons/attachment-download.svg" alt="download" class="icon">
                      <span class="text"
                      fiTranslation="REQUEST_DETAIL_FILES_TABLE_ACTION_DOWNLOAD"></span>
                    </a>
                  </button>
                  <button mat-menu-item class="menu-action-btn"
                    (click)="clipboardHelper.copyToClipboard(doc.OpenURL)">
                    <img src="assets/icons/attachment-copy-link.svg" alt="link" class="icon">
                    <span class="text"
                    fiTranslation="REQUEST_DETAIL_FILES_TABLE_ACTION_COPY"></span>
                  </button>
                  <button mat-menu-item class="menu-action-btn delete" (click)="deleteDocument(doc)">
                    <img src="assets/icons/attachment-delete-file.svg" alt="link" class="icon">
                    <span class="text"
                    fiTranslation="REQUEST_DETAIL_FILES_TABLE_ACTION_DELETE"></span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

</div>
</div>
